import { twMerge } from "tailwind-merge";
import { initials, stringToColor } from "@/lib/utils";

interface AvatarProps {
  name: string;
  className?: string;
  colorise?: boolean;
  size?: 'xs' |'sm' | 'md' | 'lg';
}

export const Avatar = ({ name, className, colorise = false, size = 'sm' }: AvatarProps) => {
  const sizeClasses = {
    xs: 'size-[9px] text-xs',
    sm: 'size-[28px] text-sm',
    md: 'size-[80px] text-xl',
    lg: 'size-[128px] text-2xl'
  };

  return (
    <div 
      style={{backgroundColor: `${stringToColor(name)}`}} 
      className={twMerge(`
        relative
        uppercase
        rounded-full
        shrink-0
        flex
        items-center
        justify-center
        text-center
        font-heading
        border-2 
        border-white 
        shadow-xl
        overflow-hidden
        ${sizeClasses[size]}
        ${colorise ? 'text-white' : 'bg-zinc-800 text-white'}
      `, className)}
    >
      {colorise && <div className="absolute inset-0 bg-black/40" />}
      <div className="relative">{initials(name)}</div>
    </div>
  );
};